export const FILE_UPLOAD_LABELS = {
  HEADER: 'File Upload',
  NOTE: '*Note: All files must be',
  CSV: 'CSV',
  DRAG_FILE: 'Drag your files here',
  OR: 'or',
  BROWSE_FILES: 'Browse Files',
  LOADING: 'Loading',
  UPLOADED: 'Uploaded',
  CANCEL: 'cancel',
  SUBMIT: 'submit',
  TRY_AGAIN: 'Try Again',
  REUPLOAD: 'Re-Upload',
  UNABLE_UPLOAD: 'Unable to Upload',
  ERROR_MESSAGE: '*Line 25: Invalid date',
  TXT: 'TXT',
  TEMPLATE_TEXT:
    'Download the template file to ensure the correct format here: ',
};

export enum UploadStatus {
  IN_PROGRESS = 'inProgress',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export type FileType = {
  progress: number;
  fileItem: File | null | never;
};
export type FileData = { file: FileType };
